import $ from "cash-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

export default (function () {
    $(document).ready(function () {
        var selector = ".chapter-title";
        if (!$(selector).length) return;

        jdmn.log("custom_chapter-title.js initialized", "green");
        gsap.registerPlugin(ScrollTrigger);

        $(selector).each(function () {
            var $instance = $(this);
            var $target = $instance.find(".thumbnail");
            var focus = $target.data("focus");
            var scale = 1.5;

            if (!focus || !scale) return;

            gsap.fromTo(
                $target[0],
                {
                    y: `${(1 - scale) * -50}%`,
                    scale: scale,
                },
                {
                    y: `${(1 - scale) * 50}%`,
                    scale: scale,
                    ease: "none",
                    force3D: true,
                    scrollTrigger: {
                        scroller: window,
                        trigger: $instance[0],
                        start: "top bottom",
                        end: "bottom top",
                        scrub: 1,
                    },
                },
            );
        });
    });
})();
